// @flow weak
import React, { Component } from 'react'
import { connect } from 'react-redux'
import {PatientActions}  from '../reducers/patient/index'
import {
    Button,
    Col,
    Row
} from '@sketchpixy/rubix'
import LoadingContainer from "../components/LoadingContainer";
import NotificationSystem from 'react-notification-system';
import {FIELD_STATUSES} from '../utils'
import * as _ from 'lodash'

class NoteRejected extends Component {
    constructor(props) {
        super(props)
        console.log("NoteRejected", JSON.stringify(props))
        this.state = {
            pDoc: props && props.location && props.location.pDoc ? props.location.pDoc : JSON.parse(sessionStorage.getItem('pDoc')),
            description: '',
            typeFlag: false,
            showSpinner: false
        }
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevState.description !== this.state.description
          ) 
            {
                if(this.state.description.length && this.state.description.length > 0) {
                    this.setState({typeFlag: true})
                } else {
                    this.setState({typeFlag: false})
                }
            }
    }

   

    addNoteDescription = () => {
        this.setState({showSpinner: true})
        let token = localStorage.getItem('login_token');
        let headers = {"Content-Type": "application/json"};
        headers["Authorization"] = `Bearer ${token}`
        fetch(process.env.API_URL+"/patients/note", {method: "post", headers, body: JSON.stringify(this.state)} )
        .then(response => response.json())
        .then(data => {
            this.setState({showSpinner: false})
            this.goToDashboard();
        })
        .catch((error) => {
        console.error('Error:', error);
        }); 
    }

    actions = link => {
        if(this.state.typeFlag) {
            this.addNoteDescription();
        }        
    }

    goBack = link => {
        const { history, location } = this.props
        history.push({ pathname: link})
    }

    goToDashboard = () => {
        let noteDisabilityId = this.state.pDoc.dbqId
        const { history } = this.props

        let correctedDbqRecords = sessionStorage.getItem("correctedDbqRecords") ? JSON.parse(sessionStorage.getItem("correctedDbqRecords")) : [];
        if (correctedDbqRecords && correctedDbqRecords.length > 0) {
            let records = []
            records = _.filter(correctedDbqRecords, function(o) { 
                return o.dbqId !== noteDisabilityId
                }); 
                sessionStorage.setItem("correctedDbqRecords", JSON.stringify(records)) 
                history.push({pathname:'/admin/corrected'})
        } else {
            history.push({ pathname: "/admin/dashboard"})
        }
    }
    

    componentWillReceiveProps(newProps) {
        let {patientInfo, fetching, isPatientUpdate, error} = newProps

        if (isPatientUpdate && !fetching) {
            const { history, location } = this.props
            history.push({pathname:'/admin/dbq', state:this.state.patient, file: patientInfo, patient:location.patient, questions: this.state.questions})
        } else {
            console.log("error", error)
            if(error) {
                this._addNotification(error, 'error', 'Error Message: ');
            }            
        }
    }
    _addNotification = (message, type, title) => {
        this._notificationSystem.clearNotifications()
        this._notificationSystem.addNotification({
            message,
            title: title,
            level: type,
            position: 'br',
            autoDismiss: 2
        })

        if (type === 'error') {
            this.setState({
                emailError: {
                    status: FIELD_STATUSES.ERROR,
                    message: ''
                },
                passwordError: {
                    status: FIELD_STATUSES.ERROR,
                    message: ''
                }
            })
        }
    }

    render() {

        
        let { description } = this.state;
        return (
            <div className="show-with-ease">
                <NotificationSystem ref='notificationSystem'/>
                {this.state.showSpinner && <LoadingContainer/>}
                <Row className="">
                <Col sm={2} className="text-center">
                    <div>{ this.state.pDoc.dbqName } </div>
                    <img className='dashboard-dbq disabality-name-tooltip dashboard-dbq-img-width' 
                        src={'/imgs/app/vbg-icons/' + this.state.pDoc.dbqName.toLowerCase() + '.png'} 
                        alt={this.state.pDoc.dbqName + ' image'}>
                    </img><div className='disabality-name-tooltip-text'>{ this.state.pDoc.patientName } </div>
                    </Col>
                    <Col sm={8} className="text-center">
                        <h1 className="heading-main"><strong>Please Tell VBG Why This DBQ is incorrect</strong></h1>
                        <div style={{marginTop:"30px"}} key="101" className="show-with-ease" >
                            <textarea 
                                name="noteDesc"
                                id="1"
                                placeholder="Please enter your reason" 
                                rows="4"
                                value={description}
                                onChange={e => this.setState({ description: e.target.value })}
                                className='required textarea-blue text-area'
                            >
                            </textarea>
        </div>
                    </Col>
                </Row>

                
                <Row className="button-bottom" style={{ bottom: 0 }}>
                    <Col smOffset={1} sm={5} style={{paddingTop: 50}}>
                        <Button
                            lg
                            type='button'
                            bsStyle=''
                            style={{border: "1px solid grey"}}
                            className="big-btn accept-btn-width"
                            onClick={this.goBack.bind(this, "/admin/compare", 0)}>Back
                            <span className="backiconspan"><svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.48866 0L9.97699 1.7625L4.08699 8.75H16.9331V11.25H4.08699L9.97699 18.2375L8.48866 20L0.0442162 10L8.48866 0Z" fill="#797979"/>
                        </svg>
                        </span>
                        </Button>
                    </Col>
                    <Col sm={5} 
                        className='text-right button-bottom' style={{paddingTop: 50}}>
                        <Button
                            lg
                            type='button'
                            bsStyle='primary'
                            className="next-btn big-btn accept-btn-width"
                            onClick={this.actions.bind(this, "/admin/dashboard")}>Send
                            {this.state.typeFlag ? <span className="nexticonspan arrow-animate"><svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.82237 0L7.33404 1.7625L13.224 8.75H0.37793V11.25H13.224L7.33404 18.2375L8.82237 20L17.2668 10L8.82237 0Z" fill="#fff"/>
                            </svg>
                            </span>: ''}
                        </Button>
                    </Col>
                </Row>

            </div>
        )
    }
}


const mapStateToProps = state => ({
    patient: {
        specific: {
            patientInfo, fetching, error, isPatientUpdate
        }
    },
  }) => {
   return {
    patientInfo,
    fetching,
    error,
    isPatientUpdate
   }
}

const mapDispatchToProps = dispatch => ({
    updatePatientDoc: (id, dbq, questions, ssn, status, patientName) => {
        dispatch(PatientActions.updateSpecificPatientRequest({
            id,
            dbq,
            questions,
            ssn,
            status,
            patientName
        }))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(NoteRejected)
